module.exports = __webpack_public_path__ + "img/img-bg-color-s2.f76008e1.jpg";